/*! @azure/msal-common v14.14.1 2024-08-13 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.14.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
